import { render, staticRenderFns } from "./AddRealm.vue?vue&type=template&id=60ee1ac0&"
import script from "./AddRealm.vue?vue&type=script&lang=js&"
export * from "./AddRealm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports